import React from "react";

const RoleToggleSkeleton: React.FC = () => {
  return (
    <div
      className="inline-flex rounded-full bg-white border border-[#D8D8D8] py-0.5 px-1 space-x-2"
      role="group"
    >
      {[1, 2, 3].map((i) => (
        <div
          key={i}
          className="relative overflow-hidden rounded-full w-24 h-8 bg-gray-200 skeleton-shimmer"
        ></div>
      ))}
    </div>
  );
};

export default RoleToggleSkeleton;

